import { expand } from 'uri-template-lite';
import { SampleUrl } from './SampleUrl';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { PageRequestParams } from '../../common/queryClient';
import { SamplePageType, SamplePageSchema } from '../schema';

interface SamplesRequestParams extends PageRequestParams {
  id: number;
  type: string;
  valueDate: string;
  sessionId?: string;
  lockState?: 'LOCKED' | 'PARTIAL' | 'NONE';
  dataSubjectName?: string;
  statusIds?: number[];
  dataManagerUsername?: string;
  dataModifiedByUsername?: string;
  dataModifiedAtFrom?: string;
  dataModifiedAtTo?: string;
}

const getSamples = async (
  params: SamplesRequestParams,
): Promise<SamplePageType> =>
  apiClient
    .get(expand(SampleUrl.all, params))
    .then((response) => SamplePageSchema.parse(response.data));

export const SAMPLES_QUERY_KEY = ['samples'] as const;

export const useSamplesQuery = createApiQueryHook(
  SAMPLES_QUERY_KEY,
  getSamples,
);
